import { createSlice } from "@reduxjs/toolkit";

const snackBarData = "";

const SnackBarDataSlice = createSlice({
    name: "snackbar",
    initialState: {
        snackBarData,
    },
    reducers: {
        reSetSnackBarData(state, action){
            state.snackBarData = ""
        },
        setSnackBarData(state, action) {
            state.snackBarData = action.payload;
        },
    },
});


export const {
    setSnackBarData,
    reSetSnackBarData
} = SnackBarDataSlice.actions;

export default SnackBarDataSlice.reducer;
